export default "__VITE_ASSET__Bpy3dsdF__"